/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Models the CodeItem
 *
 * @class CodeItem
 */
class CodeItem {
  /**
   * Creates an instance of CodeItem.
   * @param {*} json
   * @memberof CodeItem
   */
  constructor(json = null) {
    if (json) {
      // string
      this.value = json.value;

      // string
      this.description = json.description;

      // integer
      this.sortOrder = json.sortOrder;

      // ChildCodeTable
      if (json.childCodeTable) {
        this.childCodeTable = new CodeTable(json.childCodeTable);
      }
    }
  }
}

/**
 * Models the CodeTable
 *
 * @class CodeTable
 */
class CodeTable {
  /**
   * Creates an instance of CodeTable.
   * @param {*} json
   * @memberof CodeTable
   */
  constructor(json = null) {
    if (json) {
      // string
      this.tableName = json.tableName;

      // string
      this.defaultValue = json.defaultValue;

      // array - CodeItem
      if (json.codeItems) {
        this.codeItems = json.codeItems.map(object => new CodeItem(object));
      } else if (json.constructor === Array) {
        this.codeItems = json.map(object => new CodeItem(object));
      }
    }
  }
}

export default {
  CodeItem,

  CodeTable,
};
